export default __webpack_public_path__ + "static/media/UI.b90433b1.png";